// directives/staggerFade.js

export default {
  mounted(el) {
    const cards = el.querySelectorAll('.fade-card');

    cards.forEach((card, index) => {
      card.classList.add('before-fade');
      card.style.transitionDelay = `${index * 0.15}s`;
    });

    const animate = () => {
      cards.forEach((card) => {
        card.classList.add('fade-in-visible');
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animate();
            observer.disconnect(); // Animate once
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(el);

    // 👇 Fallback: Animate immediately if already visible (e.g., routed in)
    setTimeout(() => {
      const rect = el.getBoundingClientRect();
      const inView = rect.top < window.innerHeight;
      if (inView) animate();
    }, 100);
  }
};
